import { BlastRadiusFieldsFragment } from "~/operations";
import { BlockOutlined, FlagOutlined, Radar } from "@mui/icons-material";
import { StatsProps } from "~/components/DetailsPage/components/Stats/Stats";
import { HealingIcon } from "~/icons";

type GetCheckStatsParams = {
  blastRadius: BlastRadiusFieldsFragment | null | undefined;
};

export function getCheckStats({
  blastRadius,
}: GetCheckStatsParams): StatsProps["stats"] {
  return [
    {
      label: "Scanned",
      value: blastRadius?.assets?.toString() || "---",
      icon: <Radar fontSize="inherit" />,
    },
    {
      label: "Exposed",
      value: blastRadius?.affected?.toString() || "---",
      icon: <FlagOutlined fontSize="inherit" />,
      onClick: () => {
        document
          .querySelector(`#affected-assets`)
          ?.scrollIntoView({ behavior: "smooth" });
      },
    },
    {
      label: "Remediated",
      value:
        blastRadius?.assets && blastRadius?.affected
          ? (blastRadius?.assets - blastRadius?.affected).toString()
          : "---",
      icon: <HealingIcon fontSize="inherit" />,
    },
    {
      label: "Exceptions",
      value: (
        (blastRadius?.snoozed || 0) + (blastRadius?.disabled || 0)
      ).toString(),
      icon: <BlockOutlined fontSize="inherit" />,
    },
  ];
}

type GetCheckBackButtonHrefParams = {
  searchParams: URLSearchParams;
  policyId?: string | undefined;
  frameworkId?: string | undefined;
  frameworkMrn?: string | undefined;
  controlId?: string | undefined;
  controlMrn?: string | undefined;
};

export function getCheckBackButtonHref({
  policyId,
  frameworkId,
  frameworkMrn,
  controlId,
  controlMrn,
  searchParams,
}: GetCheckBackButtonHrefParams): string {
  if (policyId) {
    return `/space/findings/policies/${policyId}?${searchParams}`;
  }

  if (frameworkId && controlId && frameworkMrn && controlMrn) {
    return `/space/compliance/${frameworkId}/controls/${controlId}/checks?${searchParams}&frameworkMrn=${frameworkMrn}&controlMrn=${controlMrn}`;
  }

  return `/space/findings/checks?${searchParams}`;
}
